<template>
  <div class="product-info" @click="productClick">
    <div class="wrapper">
      <img
        class="product-icon"
        :src="item.goods_image_url"
      />
      <!-- v-lazy="item.goods_img_480 || item.goods_image_url" -->
      <span class="product-title">{{ item.goods_name }}</span>
      <div class="product-bottom">
        <span class="product-price"
          >$<i class="price">{{ item.goods_promotion_price }}</i></span
        >
        <!-- <span class="product-buy">{{ item.goods_salenum }} {{ $t('Sold') }}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexProductBody",
  data() {
    return {
      itemWidth: 0,
      itemHeight: 0,
      showRightBorder: this.index % 2 == 0,
    };
  },
  props: ["item", "index"],
  computed: {},
  methods: {
    productClick: function () {
      this.$router.push({
        name: "HomeGoodsdetail",
        query: { goods_id: this.item.goods_id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  border-right: 1px solid #f5f5f5;
}

.product-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 50%;
  box-sizing: border-box;

  .wrapper {
    background-color: #fff;
    box-shadow: 0px 2px 4px #ececec;
    // margin-left: $pageSpace;
    margin: 0 0.3rem;
    margin-bottom: 0.5rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .product-icon {
    align-self: center;
    max-width: 100%;
    height: 6rem;
    box-sizing: border-box;
    border-radius: 0.4rem;
  }

  .product-title {
    color: $formInputColor;
    font-size: $subFontSize;
    line-height: 0.8rem;
    height: 1.6rem;
    margin-top: 0.4rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    padding: 0 0.3rem;
  }

  .product-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 0.4rem;
    line-height: 1rem;
    padding: 0 0.3rem;
    padding-bottom: 0.5rem;

    .product-price {
      color: $primaryColor;
      font-size: $fontSize;

      .price {
        font-size: $mainFontSize;
      }
    }

    .product-buy {
      color: $descTextColor;
      font-size: $fontSize;
    }
  }
}
</style>
